import { createRouter, createWebHashHistory } from 'vue-router'
import HomePage from '../views/HomePage'
import AllSources from '../views/AllSources'
import CoursesChoice from '../views/CoursesChoice'
import TestChoice from '../views/TestChoice.vue'
import TestSolve from '../views/TestSolve.vue'
import TestCompleted from '../views/TestCompleted.vue'
import RegisterUser from '../views/RegisterUser.vue'
import LogIn from '../views/LogIn.vue'
import PageNotFound from '../views/PageNotFound.vue'
import ServerError from '../views/ServerError.vue'
import store from "@/store";

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomePage,
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterUser
  },
  {
    path: '/login',
    name: 'login',
    component: LogIn
  },
  {
    path: '/courses',
    name: 'courses',
    component: CoursesChoice,
    meta: { requiresAuth: true }
  },
  {
    path: '/sources',
    name: 'sources',
    component: AllSources,
    meta: { requiresAuth: true },
    beforeEnter(to) {
      const localScore = store.state.score;
      if(!localScore)
      return {
        name: "courses",
        params: { pathMatch: to.path.substring(1).split("/")},
        query: to.query,
        hash: to.hash
      };
    }
  },
  {
    path: '/courses/:id/tests',
    name: 'test-choice',
    component: TestChoice,
    props: true,
    meta: { requiresAuth: true },

    beforeEnter(to) {
      const id = parseInt(to.params.id);
      const localCourses = store.state.courses;
      const exists = localCourses.some((course)=> (course.id === 1 || course.id === 2) && course.id === id)
      if(!exists)
      return {
        name: "courses",
        params: { pathMatch: to.path.substring(1).split("/courses")},
        query: to.query,
        hash: to.hash
     };
    }
  },
  {
    path: '/courses/tests/solve',
    name: 'test',
    component: TestSolve,
    props: true,
    meta: { requiresAuth: true },

    beforeEnter(to) {
      const localTest = store.state.testChoice;
      if(!localTest)
      return {
        name: "home",
        params: { pathMatch: to.path.substring(1).split("/")},
        query: to.query,
        hash: to.hash
      };
    }
  },
  {
    path: '/courses/tests/result',
    name: 'result',
    component: TestCompleted,
    meta: { requiresAuth: true },
    beforeEnter(to) {
      const localScore = store.state.score;
      if(!localScore)
      return {
        name: "home",
        params: { pathMatch: to.path.substring(1).split("/")},
        query: to.query,
        hash: to.hash
      };
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'notFound',
    component: PageNotFound,
  },
  {
    path: '/serverError',
    name: 'serverError',
    component: ServerError,
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem('user')

  if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn) {
    next('/')
    return
  }
  next()
  return
})



export default router
